{
  "name": "@pharmaledgerassoc/ptp-frontend-ew",
  "version": "1.0.4",
  "description": "PTP Frontend EW",
  "scripts": {
    "local:compose:restart": "DOCKER_APP=pdm-frontend node ./bin/local-docker-trafeik.js",
    "do-install": "NPM_TOKEN=$(cat .npmtoken) npm install",
    "postinstall": "node ./bin/postinstall.mjs",
    "start": "npm run patch-env:local && npx rimraf .angular && ng serve --port=8130 --configuration development",
    "start:docker": "node ./bin/postinstall.mjs && ng serve --host 0.0.0.0 --allowed-hosts app --port=8130 --configuration development",
    "start:ptp": "node ./bin/postinstall.mjs && npm run patch-env:docker && npx rimraf .angular && ng serve --host 0.0.0.0 --allowed-hosts app --port=8131 --configuration development",
    "start:pdm": "node ./bin/postinstall.mjs && npm run patch-env:pdm && npx rimraf .angular && ng serve --host 0.0.0.0 --allowed-hosts app --port=8130 --configuration development",
    "server": "npm run start",
    "pwa": "npm run patch-env:local && npx rimraf .angular && npm run build && http-server www -p 8130",
    "pwa:pdm": "npm run patch-env:pdm && npx rimraf .angular && npm run build:prod && http-server www -p 8130",
    "pwa:ptp": "npm run patch-env:ptp && npx rimraf .angular && npm run build:prod  && http-server www -p 8131",
    "prebuild": "node ./bin/postinstall.mjs",
    "build:prod": "node ./bin/postinstall.mjs && ng build --configuration production",
    "build": "ng build --configuration development",
    "watch": "ng build --watch --port=8130 --configuration development",
    "lint": "ng lint",
    "lint-fix": "ng lint --fix .",
    "patch-env:docker": "ENV_CONTEXT=docker node ./bin/patch-env.js",
    "patch-env:pdm": "ORG_NAME=pdm ENV_CONTEXT=docker node ./bin/patch-env.js",
    "patch-env:local": "ENV_CONTEXT=local node ./bin/patch-env.js",
    "patch-env:dev": "ENV_CONTEXT=dev node ./bin/patch-env.js",
    "test": "npm run test:all",
    "test:all": "jest --runInBand --passWithNoTests",
    "test:components": "jest --runInBand --passWithNoTests @decaf-ts/for-angular",
    "test:services": "jest --runInBand --passWithNoTests @decaf-ts/for-angular/services",
    "playwright": "npx playwright test --config=./playwright.config.ts",
    "playwright-ui": "npx playwright test --config=./playwright.config.ts --ui",
    "playwright-setup": "npm init playwright@latest",
    "prepare-release": "npm run build",
    "release": "./bin/tag-release.sh",
    "audit-fix": "NPM_TOKEN=$(cat .npmtoken) npm audit fix",
    "update-dependencies": "NPM_TOKEN=$(cat .npmtoken) npm run update-ptp && npm run update-decaf",
    "update-decaf": "PREFIX=\"decaf-ts\"; npm ls | grep \"$PREFIX\" | awk -F/ '{print $NF}' | sed 's/@.*//' | xargs -I package npm update @\"$PREFIX\"/package",
    "update-ptp": "PREFIX=\"pharmaledgerassoc\"; npm ls | grep \"$PREFIX\" | awk -F/ '{print $NF}' | sed 's/@.*//' | NPM_TOKEN=$(cat .npmtoken) xargs -I package  npm update @\"$PREFIX\"/package",
    "update-scripts": "npx update-scripts",
    "on-first-run": "npx update-scripts --boot",
    "set-git-auth": "git config url.\"https://api:$(cat .token)@github.com/\".insteadOf \"https://github.com/\" && git config url.\"https://ssh:$(cat .token)@github.com/\".insteadOf \"ssh://git@github.com/\" && git config url.\"https://git:$(cat .token)@github.com/\".insteadOf \"git@github.com:\"",
    "flash-forward": "npx npm-check-updates -u && npm run do-install",
    "reset": "rm -rf * && git checkout . && git pull && npm run do-install",
    "increase:fs:watches": "sudo sysctl -n -w fs.inotify.max_user_watches=1048576 && sudo sysctl -n -w fs.inotify.max_user_instances=512",
    "coverage": "rimraf ./workdocs/reports/data/*.json && npm run test:all -- --coverage --config=./workdocs/reports/jest.coverage.config.ts",
    "prepare-pr": "npm run lint-fix && npm run build:prod && npm run coverage && npm run docs",
    "drawings": "for FILE in workdocs/drawings/*.drawio; do echo \"converting $FILE to image...\" && docker run --rm -v $(pwd):/data rlespinasse/drawio-export --format png $FILE; done && cp -rf workdocs/drawings/export/* workdocs/resources/",
    "uml": "cd workdocs/uml && for FILE in ./*.puml; do docker run --rm -v $(pwd):/work -w /work miy4/plantuml -DPLANTUML_LIMIT_SIZE=8192 -tpng $FILE; done && cd ../.. && cp -fr workdocs/uml/*.png workdocs/resources/",
    "docs": "npx rimraf ./docs && mkdir docs && npx build-scripts --docs",
    "publish-docs": "docker run -it --rm --user $(id -u):$(id -g) -v \"$(pwd)/workdocs/confluence:/content\" -e ATLASSIAN_API_TOKEN=$(cat .confluence-token) ghcr.io/markdown-confluence/publish:latest",
    "docker:login": "docker login ghcr.io -u user -p $(cat .token)",
    "docker:build": "DOCKER_BUILDKIT=1 docker build --no-cache --secret id=TOKEN,src=$PWD/.npmtoken -t ghcr.io/pharmaledgerassoc/ptp-frontend-ew:$(cat package.json | jq -r '.version') -t ghcr.io/pharmaledgerassoc/ptp-frontend-ew:${VERSION:-latest} -f ./Dockerfile .",
    "docker:build-base": "DOCKER_BUILDKIT=1 docker build --secret id=TOKEN,src=$PWD/.npmtoken -t ghcr.io/pharmaledgerassoc/ptp-frontend-ew:base-$(cat package.json | jq -r '.version') -t ghcr.io/pharmaledgerassoc/ptp-frontend-ew:base-${VERSION:-latest} --target base -f ./Dockerfile .",
    "docker:publish": "docker push ghcr.io/pharmaledgerassoc/ptp-frontend-ew:$(cat package.json | jq -r '.version') && docker push ghcr.io/pharmaledgerassoc/ptp-frontend-ew:${VERSION:-latest}",
    "docker:publish-base": "docker push ghcr.io/pharmaledgerassoc/ptp-frontend-ew:base-$(cat package.json | jq -r '.version') && docker push ghcr.io/pharmaledgerassoc/ptp-frontend-ew:base-${VERSION:-latest}",
    "docker:publish-local": "npm run docker:login && DOCKER_BUILDKIT=1 docker build --secret id=TOKEN,src=$PWD/.npmtoken -t ghcr.io/pharmaledgerassoc/ptp-frontend-ew-local:$(cat package.json | jq -r '.version') -t ghcr.io/pharmaledgerassoc/ptp-frontend-ew-local:${VERSION:-latest} -f ./Dockerfile . && docker push ghcr.io/pharmaledgerassoc/ptp-frontend-ew-local:$(cat package.json | jq -r '.version') && docker push ghcr.io/pharmaledgerassoc/ptp-frontend-ew-local:${VERSION:-latest}",
    "docker:run-local": "docker run -d --frontend-local -p 8080:80 ghcr.io/pharmaledgerassoc/ptp-frontend-ew-local:latest",
    "docker:remove-local": "docker rm -f $(docker ps -a -q --filter \"ancestor=ptp-frontend-ew-local\") 2>/dev/null || true && docker rm -f $(docker ps -a -q --filter \"name=ptp-frontend-ew-local\") 2>/dev/null || true && ids=$(docker images | grep 'ptp-frontend-ew-local' | awk '{print $3}') [ -n \"$ids\" ] && docker rmi -f"
  },
  "files": [
    "lib",
    "dist"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/pharmaledgerassoc/ptp-frontend-ew.git"
  },
  "engines": {
    "node": ">=20.0.0",
    "npm": ">=10.0.0"
  },
  "keywords": [
    "plantuml",
    "mermaid",
    "uml",
    "drawio",
    "mddocs",
    "md",
    "jsdoc",
    "doc",
    "docs",
    "documentation",
    "test",
    "reports",
    "confluence",
    "ci/cd",
    "ci",
    "cd",
    "template",
    "typescript",
    "ts"
  ],
  "author": "PLA",
  "bugs": {
    "url": "https://github.com/pharmaledgerassoc/ptp-frontend-ew/issues"
  },
  "homepage": "https://github.com/pharmaledgerassoc/ptp-frontend-ew#readme",
  "dependencies": {
    "@angular-builders/custom-webpack": "^21.1.0",
    "@angular/animations": "^21.2.17",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/platform-browser": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@angular/service-worker": "^21.2.17",
    "@bwip-js/browser": "^4.8.0",
    "@decaf-ts/core": "latest",
    "@decaf-ts/db-decorators": "latest",
    "@decaf-ts/decoration": "latest",
    "@decaf-ts/decorator-validation": "latest",
    "@decaf-ts/for-angular": "0.5.18",
    "@decaf-ts/for-http": "latest",
    "@decaf-ts/injectable-decorators": "latest",
    "@decaf-ts/logging": "latest",
    "@decaf-ts/styles": "latest",
    "@decaf-ts/transactional-decorators": "latest",
    "@decaf-ts/ui-decorators": "latest",
    "@ionic/angular": "^8.7.4",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@pharmaledgerassoc/ptp-toolkit": "latest",
    "@pharmaledgerassoc/ptp-xml": "^0.3.2",
    "@tabler/icons-webfont": "3.31.0",
    "@xterm/addon-fit": "^0.11.0",
    "@xterm/xterm": "^6.0.0",
    "ionicons": "^7.4.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/schematics": "^21.2.9",
    "@angular/build": "^21.2.15",
    "@angular/cli": "^21.2.9",
    "@angular/compiler-cli": "^21.2.9",
    "@decaf-ts/cli": "latest",
    "@decaf-ts/for-fabric": "latest",
    "@decaf-ts/utils": "latest",
    "@ionic/angular-toolkit": "^12.1.1",
    "@playwright/test": "^1.54.1",
    "@types/jest": "^30.0.0",
    "@types/node": "^22.15.24",
    "@typescript-eslint/eslint-plugin": "^8.18.0",
    "@typescript-eslint/parser": "^8.18.0",
    "angular-eslint": "^21.2.9",
    "dotenv": "^17.2.3",
    "dotenv-cli": "^11.0.0",
    "dotenv-expand": "^12.0.3",
    "eslint": "^9.29.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "ffmpeg-static": "5.2.0",
    "http-server": "^14.1.1",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "^16.1.4",
    "rimraf": "^6.0.1",
    "ts-node": "^10.9.2",
    "tslib": "^2.3.0",
    "typescript": "~5.9.0",
    "typescript-eslint": "8.59.2"
  },
  "overrides": {
    "esbuild": "^0.28.1",
    "minimatch": "^10.2.2",
    "test-exclude": "^7.0.2",
    "serialize-javascript": "^7.0.2",
    "undici": "^7.10.0",
    "sockjs": "^0.3.24",
    "fabric-common": {
      "jsrsasign": "^11.1.0"
    },
    "fabric-ca-client": {
      "jsrsasign": "^11.1.0"
    },
    "vite": "^7.3.5",
    "postcss": "^8.5.10",
    "uuid": "^11.1.0",
    "ip-address": "^10.1.1",
    "basic-ftp": "^5.3.1",
    "axios": "^1.15.2",
    "hono": "^4.12.25",
    "fast-uri": "^3.1.2",
    "protobufjs": "^7.5.6",
    "@babel/preset-env": "^7.29.5",
    "piscina": "^4.9.3",
    "http-proxy-middleware": "^3.0.7",
    "form-data": "^4.0.6",
    "brace-expansion": "^5.0.8",
    "@hono/node-server": ">=2.0.5",
    "webpack-dev-server": ">=5.2.6",
    "less": ">=4.7.0",
    "elliptic": "^6.6.1",
    "hashicorp-vault": "npm:tslib@^2.8.1",
    "onelogin-node": "npm:tslib@^2.8.1",
    "keycloak-admin": "npm:tslib@^2.8.1",
    "xslt-polyfill": "npm:tslib@^2.8.1"
  }
}
